module.exports = __webpack_public_path__ + "static/media/billing_icon.26b00115.svg";